// <s-sticky-atc> slides a compact add-to-cart bar up from the bottom of the screen once the
// main product form (data-target) has scrolled above the viewport, and hides it again when
// the form is back in view. While hidden it is inert so it can't be tabbed to or read out.
// It is re-rendered with the product-form partial on variant changes; connectedCallback
// re-binds the observer each time.

class SStickyAtc extends HTMLElement {
  #observer;

  connectedCallback() {
    const target = document.getElementById(this.dataset.target || '');
    if (!target || !('IntersectionObserver' in window)) return;

    this.#observer = new IntersectionObserver(([entry]) => {
      const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      this.#setVisible(scrolledPast);
    });
    this.#observer.observe(target);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  #setVisible(visible) {
    this.toggleAttribute('data-visible', visible);
    this.inert = !visible;
  }
}

if (!customElements.get('s-sticky-atc')) customElements.define('s-sticky-atc', SStickyAtc);
